import { render, staticRenderFns } from "./DetailView.vue?vue&type=template&id=45549d5c&scoped=true&"
import script from "./DetailView.vue?vue&type=script&lang=js&"
export * from "./DetailView.vue?vue&type=script&lang=js&"
import style0 from "./DetailView.vue?vue&type=style&index=0&id=45549d5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45549d5c",
  null
  
)

export default component.exports